//Bibliotecas
import Axios from 'axios';
//Modelos
import DadosEndereco from '../models/DadosEndereco';

/**
 * Classe para consultar dados do CEP
 */
class CepController {

    async consultarCep(cep) {
        try {
            const { data: dadosEndereco, erro } = await Axios.get(`https://viacep.com.br/ws/${cep}/json/`);
            if (!erro) {
                return DadosEndereco.clone({ 
                    logradouro: dadosEndereco.logradouro, 
                    bairro: dadosEndereco.bairro, 
                    municipio: dadosEndereco.localidade, 
                    uf: dadosEndereco.uf,
                    cep: cep
                });
            }
        } catch (error) {
            //Nada
        }
        return new DadosEndereco();
    }
}

export default CepController;